export default __webpack_public_path__ + "static/media/class4.224e773f.png";